module.exports = __webpack_public_path__ + "img/af.9cce1a52.png";